module.exports = __webpack_public_path__ + "img/success_b.949a529a.gif";